import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import CustomCollectionPanoRoomStep from '../../components/CustomCollectionPanoRoomStep/CustomCollectionPanoRoomStep';
import Panoramic from '../../components/Panoramic/Panoramic';

import useFetch from '../../hooks/useFetch';

import { StyledPanoGridDiv, StyledDiv, StyledH3 } from './CustomCollectionPanoRoomStyles';

var CustomCollectionPanoRoom = function CustomCollectionPanoRoom(props) {
  useEffect(function () {
    var bottomSection = document.querySelector('.custom-collection-template__bottom-section');
    if (bottomSection) {
      bottomSection.style.display = 'block';
    }
  }, []);

  var panoImageFetch = useFetch('/collections/' + props.handle + '?view=panoimage');

  var panoImage = panoImageFetch && panoImageFetch.panoImage !== '' ? panoImageFetch.panoImage : props.collectionImage;
  return React.createElement(
    StyledPanoGridDiv,
    null,
    React.createElement(
      'div',
      null,
      React.createElement(
        StyledDiv,
        { className: 'custom-collection__step-details' },
        React.createElement(
          StyledH3,
          null,
          props.collectionTitle
        )
      ),
      React.createElement(Panoramic, { panoHeroImage: panoImage, nonPano: props.nonPano }),
      props.steps.map(function (step, index) {
        return React.createElement(CustomCollectionPanoRoomStep, {
          key: step.title,
          step: step,
          stepIndex: index,
          roomPanoCollectionId: props.roomPanoCollectionId,
          addVariantToCart: props.addVariantToCart,
          checkout: props.checkout,
          collectionTitle: props.collectionTitle,
          openProductModal: props.openProductModal,
          wishlistProducts: props.wishlistProducts,
          toggleAccountModal: props.toggleAccountModal,
          customCollectionImages: Object.values(props.customCollectionImages)
        });
      })
    )
  );
};

CustomCollectionPanoRoom.propTypes = {
  collectionTitle: PropTypes.string.isRequired,
  descriptionHtml: PropTypes.string.isRequired,
  collectionImage: PropTypes.string,
  customCollectionImages: PropTypes.object,
  wishlistProducts: PropTypes.array,
  handleCartOpen: PropTypes.func,
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  toggleAccountModal: PropTypes.func.isRequired,
  openProductModal: PropTypes.func.isRequired,
  roomPanoCollectionId: PropTypes.string,
  steps: PropTypes.array.isRequired,
  nonPano: PropTypes.bool,
  handle: PropTypes.string.isRequired
};

export default CustomCollectionPanoRoom;